import {
  type PersonLimit,
  type PersonLimitRequest,
  PersonLimitType,
  type UserPrice as UserPriceDto,
  type UserPriceRequest as UserPriceRequestDto,
} from '@mynt/backoffice-api-spec/person'
import type {
  UserPrice,
  UserPriceRequest,
  UserSettings,
  UserSettingsLimited,
  UserSettingsRequest,
  UserSettingsUnlimited,
  UsersLimit,
} from './api'

export const mapPersonLimitToUserSettings = (personLimit: PersonLimit): UserSettings => {
  // TODO: remove these enum strings once the endpoint bug is fixed and returns enums according to the spec
  const brokenLimit = 'LimitedPersonLimit' as 'limited'
  const brokenUnlimited = 'UnlimitedPersonLimit' as 'unlimited'

  switch (personLimit.limit.type) {
    case brokenLimit:
    case PersonLimitType.LIMITED: {
      return {
        isOverriden: personLimit.isOverridden,
        limit: {
          type: 'limited',
          allowedUsers: personLimit.limit.limit,
        },
      }
    }

    case brokenUnlimited:
    case PersonLimitType.UNLIMITED: {
      return {
        isOverriden: personLimit.isOverridden,
        limit: {
          type: 'unlimited',
        },
      }
    }
  }
}

export const mapUserSettingsRequestToPersonLimitRequest = (userSettings: UserSettingsRequest): PersonLimitRequest => {
  switch (userSettings.limit.type) {
    case 'limited': {
      return {
        limit: {
          limit: userSettings.limit.allowedUsers,
          type: 'limited',
        },
      }
    }

    case 'unlimited': {
      return {
        limit: {
          type: 'unlimited',
        },
      }
    }
  }
}

export const mapUserPriceDtoToUserPrice = (userPrice: UserPriceDto): UserPrice => ({
  isOverriden: userPrice.isOverridden,
  pricePerUser: {
    value: userPrice.pricePerPerson.value,
    currency: userPrice.pricePerPerson.currency,
  },
  numberOfFreeUsers: userPrice.numberOfFreeUsers,
  numberOfBilledUsers: userPrice.numberOfBilledUsers ?? -1,
})

export const mapUserPriceToUserPriceRequestDto = (userPrice: UserPriceRequest): UserPriceRequestDto => ({
  pricePerPerson: {
    value: userPrice.pricePerUser.value,
    currency: userPrice.pricePerUser.currency,
  },
  numberOfFreeUsers: userPrice.numberOfFreeUsers,
})

export const isUserSettingsLimited = (userSettings: UsersLimit): userSettings is UserSettingsLimited => {
  return userSettings.type === 'limited'
}

export const isUserSettingsUnlimited = (userSettings: UsersLimit): userSettings is UserSettingsUnlimited => {
  return userSettings.type === 'unlimited'
}
